// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.devices-header {
  font-size: 1rem;
  font-weight: normal;
  text-align: center;
  flex-grow: 1;
  color: #000; /* Change to black */
  line-height: 1.5; /* Ensure consistent height with the Back button */
  margin-top: 0; /* Remove margin-top to fix height difference */
}

.settings-back-button {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  font: inherit;
  margin-bottom: 0; /* Ensure consistent spacing */
  font-size: 1rem; /* Match font size with My Devices */
  line-height: 1.5; /* Ensure consistent height with My Devices */
}

.settings-back-button:hover {
  text-decoration: underline;
}

.devices-page-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
}

.devices-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.devices-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.device-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.device-browser {
  font-size: 1rem;
  font-weight: bold;
  color: #374151;
}

.device-divider {
  border: none;
  height: 1px;
  background-color: #e5e7eb;
  margin: 4px 0;
}

.device-info {
  font-size: 0.875rem;
  color: #6b7280;
}`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal/Devices/DevicesPage.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW,EAAE,oBAAoB;EACjC,gBAAgB,EAAE,kDAAkD;EACpE,aAAa,EAAE,+CAA+C;AAChE;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB,EAAE,8BAA8B;EAChD,eAAe,EAAE,oCAAoC;EACrD,gBAAgB,EAAE,6CAA6C;AACjE;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".devices-header {\n  font-size: 1rem;\n  font-weight: normal;\n  text-align: center;\n  flex-grow: 1;\n  color: #000; /* Change to black */\n  line-height: 1.5; /* Ensure consistent height with the Back button */\n  margin-top: 0; /* Remove margin-top to fix height difference */\n}\n\n.settings-back-button {\n  background: none;\n  border: none;\n  color: #007bff;\n  cursor: pointer;\n  font: inherit;\n  margin-bottom: 0; /* Ensure consistent spacing */\n  font-size: 1rem; /* Match font size with My Devices */\n  line-height: 1.5; /* Ensure consistent height with My Devices */\n}\n\n.settings-back-button:hover {\n  text-decoration: underline;\n}\n\n.devices-page-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 24px;\n}\n\n.devices-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n}\n\n.devices-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.device-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.device-browser {\n  font-size: 1rem;\n  font-weight: bold;\n  color: #374151;\n}\n\n.device-divider {\n  border: none;\n  height: 1px;\n  background-color: #e5e7eb;\n  margin: 4px 0;\n}\n\n.device-info {\n  font-size: 0.875rem;\n  color: #6b7280;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
